import { primaryColor, t } from "./theme.ts";

export const NotFound = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "80vh",
      color: primaryColor(),
      gap: 16,
      textAlign: "center",
    }}
  >
    <div style={{ fontSize: 80, lineHeight: 1 }}>😕</div>
    <div style={{ fontSize: 32, fontWeight: 700 }}>Page not found</div>
    <div style={{ color: t().textMuted, fontSize: 18, marginBottom: 12 }}>
      Sorry, we couldn't find what you're looking for.
    </div>
    <button
      type="button"
      className="compact-button"
      style={{ fontSize: 18, padding: "8px 28px", marginTop: 8 }}
      onClick={() => (globalThis.location.href = "/")}
    >
      Go to Home
    </button>
  </div>
);
